import { BaseApiClient } from "./BaseApiClient";
import { TypeExtends } from "sb-js-extends";
TypeExtends();
export const RACES_ENDPOINTS = {
    BY_ID: "/Races/{0}",
    ALL: "/Races",
    COMPACT: "/Races/Compact"
};
/**
 * RacesApiClient - client for fetching races from BFF
 * @exports
 * @class RacesApiClient
 * @extends BaseApiClient
 */
export class RacesApiClient extends BaseApiClient {
    /**
     * Get a race by race id from BFF
     * @param {string} raceId id of a race
     * @throws {RequiredError}
     * @memberof RacesApiClient
     */
    getById(raceId) {
        let fetchOptions = {
            request: {},
            fetchOptOverride: {
                method: "GET",
                headers: {
                    "Cache-Control": "no-cache"
                }
            }
        };
        return this.executeRequest(RACES_ENDPOINTS.BY_ID.format(raceId), fetchOptions);
    }
    /**
     * Get races by league id from BFF
     * @throws {RequiredError}
     * @memberof RacesApiClient
     */
    getRaces(request) {
        let fetchOptions = {
            request: {},
            fetchOptOverride: {
                method: "GET",
                headers: {
                    "Cache-Control": "no-cache"
                }
            }
        };
        let queryItems = request.leagueIds ? request.leagueIds.map(x => `LeagueIds=${x}`) : [];
        request.paginationTop && queryItems.push(`Pagination.Top=${request.paginationTop}`);
        request.paginationSkip && queryItems.push(`Pagination.Skip=${request.paginationSkip}`);
        let queryString = queryItems.join("&");
        return this.executeRequest(RACES_ENDPOINTS.ALL + `?${queryString}`, fetchOptions);
    }
    /**
     * Get all races with no participants and tote details from BFF
     * @throws {RequiredError}
     * @memberof RacesApiClient
     */
    getRacesCompact() {
        let fetchOptions = {
            request: {},
            fetchOptOverride: {
                method: "GET",
                headers: {
                    "Cache-Control": "no-cache"
                }
            }
        };
        return this.executeRequest(RACES_ENDPOINTS.COMPACT, fetchOptions);
    }
}
//# sourceMappingURL=RacesApiClient.js.map